export const TEMPLATE_COLS = '30% 15% 15% 15% 25%';
